// Function definitions
const index = function (params) {
    return window.axios.get('/api/product-categories', {params});
};

const get = function (id) {
    return window.axios.get(`/api/product-categories/${id}`);
};

const create = function (data) {
    return window.axios.post('/api/product-categories', data);
};

const update = function (data) {
    return window.axios.put(`/api/product-categories/${data.id}`, data);
};

const deleteProductCategory = function (id) {
    return window.axios.delete(`/api/product-categories/${id}`);
};

const save = function (data) {
    if (data.id) {
        return update(data);
    }
    return create(data);
};

export default {
    index,
    get,
    create,
    update,
    delete: deleteProductCategory,
    save,
};


// WEBPACK FOOTER //
// ./resources/assets/js/services/ProductCategoriesService.js